module.exports = __webpack_public_path__ + "img/estrella_barra.c7385df7.svg";